import styled from 'styled-components';

export const FootnoteRendererStyle = styled.ul`
	display: grid;
	row-gap: 0.5rem;

	li {
		display: flex;
		gap: 1rem;
	}
`;
